module.exports = __webpack_public_path__ + "static/media/Value-Based Leadership Performance.672c1c00.pdf";